import { Link } from "react-router-dom";
import { ChevronRight, GripVertical } from "lucide-react";
import type { DragHandleProps } from "../../constants";

interface WidgetProps {
  title: string;
  icon: React.ReactNode;
  linkTo: string;
  linkText?: string;
  dragHandleProps?: DragHandleProps;
  children: React.ReactNode;
}

export const Widget = ({
  title,
  icon,
  linkTo,
  linkText = "View all",
  dragHandleProps,
  children,
}: WidgetProps) => {
  return (
    <div className="bg-muted/50 rounded-3xl flex flex-col h-full shadow-xs overflow-hidden">
      <div className=" flex items-center justify-between min-h-12 p-2 border-b border-border dark:border-border/60">
        <div className="flex items-center gap-2 pl-2">
          {dragHandleProps && (
            <button
              type="button"
              className="text-muted-foreground hover:text-foreground cursor-grab active:cursor-grabbing transition-colors -ml-1"
              {...dragHandleProps.attributes}
              {...dragHandleProps.listeners}
            >
              <GripVertical className="size-4" aria-hidden="true" />
            </button>
          )}
          <span className="text-muted-foreground" aria-hidden="true">
            {icon}
          </span>
          <h3 className="text-foreground font-semibold">{title}</h3>
        </div>
        <Link
          to={linkTo}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1 cursor-pointer dark:bg-white/10 hover:dark:bg-white/20 rounded-full px-3 pr-2 py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {linkText}
          <ChevronRight className="size-3" aria-hidden="true" />
        </Link>
      </div>
      <div className="p-3 flex-1 flex flex-col">
        {children}
      </div>
    </div>
  );
};
